import { ChangeDetectionStrategy, Component, inject, viewChild } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { ButtonModule } from 'primeng/button';
import { Popover, PopoverModule } from 'primeng/popover';

import { PtLanguageService } from '@pt/services/language';

@Component({
  selector: 'pt-language-selector',
  imports: [ButtonModule, PopoverModule, TranslocoPipe],
  templateUrl: './language-selector.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PtLanguageSelectorComponent {
  private readonly translocoService = inject(TranslocoService);
  private readonly languageService = inject(PtLanguageService);

  readonly availableLangs = this.translocoService.getAvailableLangs() as string[];

  readonly activeLang = toSignal(this.translocoService.langChanges$, {
    initialValue: this.translocoService.getActiveLang(),
  });

  readonly popover = viewChild.required<Popover>('popover');

  togglePopover(event: Event): void {
    this.popover().toggle(event);
  }

  setLang(lang: string): void {
    void this.languageService.setLanguage(lang);
    this.popover().hide();
  }

  getLangLabel(lang: string): string {
    return lang.split('-')[0].toUpperCase();
  }
}
